import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, ButtonBase, Stack } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import AppModal from 'components/shared/AppModal';

const propTypes = {
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      identifier: PropTypes.string,
      contentType: PropTypes.string.isRequired,
    })
  ).isRequired,
  containerClassName: PropTypes.string,
}

const defaultProps = {
}

const CustomerTicketAttachments = (props) => {
  const [focusedMedia, setFocusedMedia] = useState(null);
  const modalRef = useRef(null);

  const handleMediaClick = (media) => {
    setFocusedMedia(media);
    modalRef.current?.open();
  }

  const { imageAttachments, otherAttachments } = props.attachments.reduce(
    (acc, mediaItem) => {
      if (mediaItem.contentType.includes('image')) {
        return { ...acc, imageAttachments: [...acc.imageAttachments, mediaItem]};
      } 
      else {
        return { ...acc, otherAttachments: [...acc.otherAttachments, mediaItem]};
      }
    },
    { imageAttachments: [], otherAttachments: [] }
  );
  
  return (
    <div className={ props.containerClassName }>
      <Stack direction="row" flexWrap="wrap" gap={1} alignItems="center">
        {/* Image attachments */}
        { imageAttachments.map((media, index) => (
          <ButtonBase
            key={index}
            onClick={ () => handleMediaClick(media)}
            sx={{ borderRadius: 1 }}
          >
            {/* Polaris' <Thumbnail size="large"> was an 80px rounded square. */}
            <Box
              component="img"
              src={ media.url }
              alt={ media.identifier }
              sx={{
                width: 80,
                height: 80,
                objectFit: 'cover',
                borderRadius: 1,
                border: 1,
                borderColor: 'divider',
              }}
            />
          </ButtonBase>
        ))}
        {/* Other attachments */}
        { otherAttachments.map((media, index) => (
          <Button
            key={index}
            variant="text"
            href={media.url}
            target="_blank"
            rel="noopener"
            startIcon={<AttachFileIcon />}
          >
            { media.identifier }
          </Button>
        ))}
      </Stack>

      <AppModal
        ref={ modalRef }
        title={ focusedMedia?.identifier || "Media" }
        large
      >
        <div className='flex justifyCenter alignItemsCenter'>
          <img
            src={focusedMedia?.url}
            alt={focusedMedia?.identifier}
            style={{
              height: "auto",
              maxWidth: "100%",
              maxHeight: "80vh",
            }}
          />
        </div>
      </AppModal>
    </div>
  )
};

CustomerTicketAttachments.propTypes = propTypes;
CustomerTicketAttachments.defaultProps = defaultProps;

export default CustomerTicketAttachments;